import * as Yup from "yup";

const requiredMessage = "Acest câmp este obligatoriu";
export const validationSchema = Yup.object({
  name: Yup.string().required(requiredMessage),
  email: Yup.string().required(requiredMessage),
  phone: Yup.string().required(requiredMessage),
  date: Yup.string().required(requiredMessage),
  time: Yup.string().required(requiredMessage),
  vehicle: Yup.string().required(requiredMessage),
  works: Yup.string().required(requiredMessage),
});
